import LightLayout from '../../../../../shared/Layouts/LightLayout'
import taskSandboxCss from '../taskSandbox.module.css'
import css from './secondTaskSandbox.module.css'
import sandboxCss from '../taskSandbox.module.css'
import CreateTextOptionModal from '../../CreateTextOptionModal'
import { ITask } from '../../../../../types/tasks.types'
import useSandboxTask from '../useSandboxTask'
import TextOption from '../../TextOption'

interface IProps {
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const SecondTaskSandbox = (props: IProps) => {
  const ctrl = useSandboxTask(props.onDraftTaskChange)

  const renderOptions = () => {
    return ctrl.draftTask.answerOptions.map((option, index) => (
      <TextOption
        option={option}
        index={index}
        key={index}
        onDelete={ctrl.handleOptionDelete}
        onChange={ctrl.handleOptionChange}
      />
    ))
  }
  return (
    <div className={taskSandboxCss.wrapper}>
      {ctrl.createOptionModalOpen && (
        <CreateTextOptionModal onClose={ctrl.toggleCreateOptionModal} onCreate={ctrl.handleOptionCreate} />
      )}
      <LightLayout>
        <div className={css.wrapper}>
          <div className={css.options}>
            {renderOptions()}
            <div className={sandboxCss.addOption} onClick={ctrl.toggleCreateOptionModal}>
              Добавить карточку
            </div>
          </div>
        </div>
      </LightLayout>
    </div>
  )
}

export default SecondTaskSandbox
